/** KAN-718: подписи журнала писем. */
import type { EmailDirection, EmailItem } from '@/types/emailMailbox';

export const EMAIL_DIRECTION_LABEL: Record<EmailDirection, string> = {
  out: 'Исходящее',
  in: 'Входящее',
};

/** Собеседник: кому для исходящего, от кого для входящего. */
export function emailCounterpart(email: EmailItem): string {
  return email.direction === 'out' ? email.to : email.from;
}

/** KAN-724: отправитель письма без привязки: "Имя <адрес>" или просто адрес. */
export function senderLabel(email: { from: string; from_name?: string }): string {
  return email.from_name ? `${email.from_name} <${email.from}>` : email.from;
}
